<template>
  <nav class="nav nav-language" ref="languageSelection" role="navigation">
    <ul class="level-1" role="menubar">
      <li class="active submenu" role="none">
        <button @keydown.space.prevent="open = !open" @click="open = !open" @keyup.up="focusPrevOption(0)" @keyup.down="focusNextOption(availableLanguages.length - 1)" class="nav_toggle" role="menuitem" aria-haspopup="true" :aria-expanded="open ? true : false">{{ convertedLaunguageToUpperCase }}</button>
        <transition name="expand">
          <ul class="level-2" v-show="open" role="menu">
          <li role="none" tabindex="0" v-for="(language, i) in availableLanguages" :key="i" :class="{active: language === activeLanguage}"
              :ref="'option' + i"
              @click="languageSelected(language)"
              @keydown.space.prevent="languageSelected(language)"
              @keyup.up="focusPrevOption(i)"
              @keyup.down="focusNextOption(i)">
            <SvgIcon v-if="language === activeLanguage" type="tick-black-thick"/>
            <a><span role="menuitem">{{ $t('language.' + language) }}</span></a>
          </li>
        </ul>
        </transition>
      </li>
    </ul>
  </nav>
</template>

<script>
import { allowedLanguages } from '@/i18n'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'LanguageSelector',
    components: {
        SvgIcon
    },
    data() {
        return {
            open: false
        }
    },
    computed: {
        availableLanguages() {
            return allowedLanguages
        },
        activeLanguage() {
            return this.$route.params.locale
        },
        convertedLaunguageToUpperCase() {
            return this.activeLanguage.toUpperCase()
        }
    },
    methods: {
        focusPrevOption(index) {
            if (index === 0) {
                index = (this.availableLanguages.length - 1)
            } else {
                index--
            }
            this.$refs['option' + index][0].focus()
        },
        focusNextOption(index) {
            if (index === (this.availableLanguages.length - 1)) {
                index = 0
            } else {
                index++
            }
            this.$refs['option' + index][0].focus()
        },
        languageSelected(language) {
            this.open = !this.open
            this.$router.push({
                name: this.$route.name,
                params: { locale: language }
            })
            window.location.reload()
        },
        documentClick(e) {
            let el = this.$refs.languageSelection
            let target = e.target
            if (el && (el !== target) && !el.contains(target)) {
                this.open = false
            }
        }
    },
    created() {
        document.addEventListener('click', this.documentClick)
    }
}
</script>
